// Physician-demo session: exchange an access key for the dataset via /api/demo/open
// (functions/demo.mjs). The dataset and the access record are kept in sessionStorage
// so a page refresh in the middle of a demo does not ask for the key again; closing
// the tab ends the session. No Firebase, no sign-in — the key is the credential.
import type { Dataset, DemoAccess } from './types';

export interface DemoSession { access: DemoAccess; dataset: Dataset; openedAt: number }
const STORE = 'demo.session.v1';

export async function openDemo(key: string): Promise<DemoSession> {
  const res = await fetch('/api/demo/open', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ key }),
  });
  const text = await res.text();
  let data: any;
  try { data = JSON.parse(text); } catch { data = { ok: false, error: text.slice(0, 200) }; }
  if (!res.ok || !data.ok) throw new Error(data.error || `HTTP ${res.status} — is the demo function deployed?`);
  const session: DemoSession = { access: data.access, dataset: data.dataset, openedAt: Date.now() };
  try { sessionStorage.setItem(STORE, JSON.stringify(session)); } catch { /* storage unavailable — session lives in memory only */ }
  return session;
}

export function savedSession(): DemoSession | null {
  try {
    const raw = sessionStorage.getItem(STORE); if (!raw) return null;
    const s = JSON.parse(raw) as DemoSession;
    if (!s || !s.dataset || !Array.isArray(s.dataset.visits)) return null;
    if (s.access?.expiresAt && s.access.expiresAt < Date.now()) { clearSession(); return null; }
    return s;
  } catch { return null; }
}

export function clearSession(): void {
  try { sessionStorage.removeItem(STORE); } catch { /* ignore */ }
}

/** Key as typed in the URL (?key=…) so an admin can send a one-click link. */
export function keyFromUrl(): string {
  try { return new URL(location.href).searchParams.get('key') ?? ''; } catch { return ''; }
}
